import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import {
    getCustomer2QualificationsFetched,
} from '../../State/selectors/mdqx/selectors';
import { State } from '../../State';
import { GetCustomer2QualificationRequest } from '../../State/actions/mdqx/customer2qualification.action';

@Injectable({
    providedIn: 'root',
})
export class Customer2qualificationResolver implements Resolve<boolean> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getCustomer2QualificationsFetched);

        value$
            .pipe(take(1))
            .subscribe(
                fetched =>
                    !fetched &&
                    localStorage.getItem('token') != null &&
                    this.store.dispatch(new GetCustomer2QualificationRequest()),
            );

        return value$.pipe(
            filter(v => v),
            take(1),
        );
    }
}
